export class DrugSearchCategoryDetails {
 groupId: number;
 therCat1Nm : string;
 therCat1MbrGuiNm : string;

  categoryDisplayValue : string;
}
